import React from "react";
import {
  useTable,
  useResizeColumns,
  useBlockLayout,
  useSortBy,
  useFilters,
} from "react-table";

import { Table, Tbody, Th, Thead, Tr, Input, Td } from "@chakra-ui/react";

function ResizableTable({ columns, data }) {
  const DefaultColumnFilter = ({
    column: { filterValue, preFilteredRows, setFilter },
  }) => {
    const count = preFilteredRows.length;

    return (
      <Input
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records`}
      />
    );
  };

  const defaultColumn = React.useMemo(
    () => ({
      minWidth: 250,
      width: 200,
      maxWidth: 1000,
      Filter: DefaultColumnFilter, // Add default filter
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setFilter,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters, // Use the useFilters hook
    useSortBy, // Use the useSortBy hook
    useBlockLayout,
    useResizeColumns
  );

  return (
    <div className="w-full h-[90%] px-5 relative overflow-x-auto shadow-md sm:rounded-lg">
      <Table
        {...getTableProps()}
        // className="w-full text-sm text-left text-color-text"
        variant="simple"
        color="gray.500"
        mb="24px"
      >
        {/* <thead className="text-xs text-color-text-2 uppercase bg-button-color bg-opacity-90">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} className="px-6 py-3 w-4/5">
                  <div className="whitespace-nowrap overflow-hidden text-ellipsis ">
                    {column.render("Header")}
                  </div>
                  <div
                    {...column.getResizerProps()}
                    className={`resizer ${
                      column.isResizing ? "isResizing" : ""
                    }`}
                  />
                </th>
              ))}
            </tr>
          ))}
        </thead> */}

        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="px-6 py-3 w-4/5 relative"
                >
                  <div className="whitespace-nowrap overflow-hidden text-ellipsis ">
                    {column.render("Header")}
                    <span className="ml-2">
                      {column.isSorted
                        ? column.isSortedDesc
                          ? "🔽"
                          : "🔼"
                        : "⏹️"}
                    </span>
                  </div>
                  <div
                    {...column.getResizerProps()}
                    className={`resizer ${
                      column.isResizing ? "isResizing" : ""
                    }`}
                  />
                </Th>
              ))}
            </Tr>
          ))}
          {/* {headerGroups[0].headers.map((column) => (
            <>{column.canFilter ? column.render("Filter") : null}</>
          ))} */}
        </Thead>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps()}
                  className="px-6 py-3 w-4/5 relative"
                >
                  {column.canFilter ? column.render("Filter") : null}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className="bg-color-text-2 border-color-text border-opacity-30 border-b"
        >
          {rows.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <Td {...cell.getCellProps()} className="px-6 py-4 w-4/5">
                    <div className="whitespace-nowrap overflow-hidden text-ellipsis ">
                      {cell.render("Cell")}
                    </div>
                  </Td>
                ))}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </div>
  );
}

export default ResizableTable;
